import { z } from "zod";

export const ASSET_ASSIGNMENTS_PAGE_SIZES = [10, 25, 50, 100] as const;

// Keep members in sync with AssetAssignmentSortBy in ../../domain/models.
export const assetAssignmentSortBySchema = z.enum([
  "branchNameEn",
  "branchNameAr",
  "assetNameEn",
  "assetNameAr",
  "assignedAt",
]);

// `from/toAssignedAt` are set together (one date-range picker).
export const assetAssignmentsSearchSchema = z
  .object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce
      .number()
      .int()
      .refine((value) =>
        (ASSET_ASSIGNMENTS_PAGE_SIZES as readonly number[]).includes(value),
      )
      .catch(10)
      .default(10),
    sort: z.enum(["asc", "desc"]).optional(),
    sortBy: assetAssignmentSortBySchema.optional(),
    // No .trim() -- the input's value is this field round-tripped through the
    // URL on every keystroke, so trimming here would eat spaces as they type.
    search: z.string().min(1).optional(),
    fromAssignedAt: z.string().datetime().optional(),
    toAssignedAt: z.string().datetime().optional(),
  })
  .refine(
    (search) =>
      (search.fromAssignedAt === undefined) ===
      (search.toAssignedAt === undefined),
  );

export type AssetAssignmentsSearch = z.infer<typeof assetAssignmentsSearchSchema>;
export type AssetAssignmentSortBySearch = z.infer<
  typeof assetAssignmentSortBySchema
>;
